module.exports = __webpack_public_path__ + "static/media/Sun Deck 2.61dd1224.jpg";